import { createContext } from 'react';
import { GlobalLoadingContextType } from '../types';

export const GlobalLoadingContext = createContext({} as GlobalLoadingContextType);
